import React from 'react';
import CompanyRestrictionsButton from '../../../components/buttons/CompanyRestrictions';
import { BASE_CURRENT_CONFIG } from '../baseConfig';
import { CURRENT_OPERATIONS_STATUS } from '../constants';
import OperationsStatusView from './OperationsStatusView';

const CurrentOperationsStatusView = (props) => (
  <OperationsStatusView
    trackerId="CESSION_STATUS"
    headerTitle="Facturas vigentes"
    headerDescription="Facturas operadas a la espera de ser giradas y recaudadas"
    statusFilter={CURRENT_OPERATIONS_STATUS}
    extraHeaderComponent={<CompanyRestrictionsButton />}
    {...BASE_CURRENT_CONFIG}
    {...props}
  />
);

export default CurrentOperationsStatusView;
